<form #createForm="ngForm" class="needs-validation" novalidate>
  <tabset [justified]="true" type="pills" class="mb-3">
    <tab [heading]="'device-setting.print-settings' | translate">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="form-check form-switch">
                  <input #isPrintReceipt="ngModel" type="checkbox" class="form-check-input" name="isPrintReceipt" id="isPrintReceipt" [(ngModel)]="deviceLocalStorageData.isPrintReceipt" />
                  <label class="form-check-label" for="isPrintReceipt">{{'device-preference.isPrintReceipt' | translate}}</label>
                </div>
                <app-number-spinner name="receiptCount" [value]="deviceLocalStorageData.receiptCount" [minValue]="0" (valueChange)="receiptCountChange($event)"></app-number-spinner>
              </div>
              <div class="form-check form-switch mb-3">
                <input #isPrintReceiptForPickupOrder="ngModel" type="checkbox" class="form-check-input" name="isPrintReceiptForPickupOrder" id="isPrintReceiptForPickupOrder"
                  [(ngModel)]="deviceLocalStorageData.isPrintReceiptForPickupOrder" />
                <label class="form-check-label" for="isPrintReceiptForPickupOrder">{{'device-preference.isPrintReceiptForPickupOrder' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #isPrintLabel="ngModel" type="checkbox" class="form-check-input" name="isPrintLabel" id="isPrintLabel" [(ngModel)]="deviceLocalStorageData.isPrintLabel" />
                <label class="form-check-label" for="isPrintLabel">{{'device-preference.isPrintLabel' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #printAdditionalReceiptAfterReadyInput="ngModel" type="checkbox" class="form-check-input" name="printAdditionalReceiptAfterReadyInput" id="printAdditionalReceiptAfterReadyInput"
                  [(ngModel)]="deviceLocalStorageData.printAdditionalReceiptAfterReady" />
                <label class="form-check-label" for="printAdditionalReceiptAfterReadyInput">{{'device-preference.printAdditionalReceiptAfterReady' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #isOpenCashRegisterAfterPrintReceipt="ngModel" type="checkbox" class="form-check-input" name="isOpenCashRegisterAfterPrintReceipt" id="isOpenCashRegisterAfterPrintReceipt"
                  [(ngModel)]="deviceLocalStorageData.isOpenCashRegisterAfterPrintReceipt" />
                <label class="form-check-label" for="isOpenCashRegisterAfterPrintReceipt">{{'device-preference.isOpenCashRegisterAfterPrintReceipt' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'device-setting.device-settings' | translate" *ngIf="device?.id>0">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <!-- <div class="form-check form-switch mb-3">
                <input #sendWhatsappMessageWithApp="ngModel" type="checkbox" class="form-check-input" name="sendWhatsappMessageWithApp" id="sendWhatsappMessageWithApp"
                  [(ngModel)]="deviceLocalStorageData.sendWhatsappMessageWithApp" />
                <label class="form-check-label" for="sendWhatsappMessageWithApp">{{'device-preference.sendWhatsappMessageWithApp' | translate}}</label>
              </div> -->
              <div class="form-check form-switch mb-3">
                <input #showClockOnHeader="ngModel" type="checkbox" class="form-check-input" name="showClockOnHeader" id="showClockOnHeader" [(ngModel)]="deviceLocalStorageData.showClockOnHeader" />
                <label class="form-check-label" for="showClockOnHeader">{{'device-preference.show-clock-on-header' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #hasCustomerScreen="ngModel" type="checkbox" class="form-check-input" name="hasCustomerScreen" id="hasCustomerScreen" [(ngModel)]="deviceLocalStorageData.hasCustomerScreen" />
                <label class="form-check-label" for="hasCustomerScreen">{{'device-preference.has-customer-screen' | translate}}</label>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="deviceNameInput">{{'device.deviceName' | translate}}</label>
                <input type="text" #deviceNameInput="ngModel" name="deviceNameInput" [(ngModel)]="device.name" required class="form-control" />
                <app-field-error-display [displayError]="deviceNameInput.invalid && deviceNameInput.touched" errorMsg="Please inform your name"></app-field-error-display>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="deviceCode">{{'device.deviceCode' | translate}}</label>
                <input type="text" #deviceCode="ngModel" name="deviceCode" [(ngModel)]="device.deviceCode" class="form-control" readonly />
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'device-setting.order-settings' | translate">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-group">
                <label class="custom-form-label" for="newOrderPaymentTypeId">{{'device-preference.newOrderPaymentType' | translate}}</label>
                <select #newOrderPaymentTypeId name="newOrderPaymentTypeId" class="form-control input-lg" [(ngModel)]="deviceLocalStorageData.newOrderPaymentTypeId">
                  <option [ngValue]="-1">{{'hint.select-payment-option' | translate}}</option>
                  <option [ngValue]="0">{{'dropdown.payment-will-be-made-later' | translate}}</option>
                  <option *ngFor="let item of paymentTypeIds" [ngValue]="item">{{ 'paymentTypeValue.'+item | translate}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="deliveryPaymentTypeId">{{'device-preference.deliveryPaymentType' | translate}}</label>
                <select #deliveryPaymentTypeId name="deliveryPaymentTypeId" class="form-control input-lg" [(ngModel)]="deviceLocalStorageData.deliveryPaymentTypeId">
                  <option [ngValue]="-1">{{'hint.select-payment-option' | translate}}</option>
                  <option [ngValue]="0">{{'dropdown.payment-will-be-made-later' | translate}}</option>
                  <option *ngFor="let item of paymentTypeIds" [ngValue]="item">{{ 'paymentTypeValue.'+item | translate}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="posDeviceId">{{'payment.posDevice' | translate}}</label>
                <select name="posDeviceId" [(ngModel)]="deviceLocalStorageData.posDeviceId" class="form-control">
                  <option [ngValue]="0">{{'dropdown.no-preference' | translate}}</option>
                  <option *ngFor="let option of posDevices" [ngValue]="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="cashRegisterIdInput">{{'payment.cashRegister' | translate}}</label>
                <select name="cashRegisterIdInput" [(ngModel)]="deviceLocalStorageData.cashRegisterId" class="form-control">
                  <option [ngValue]="0">{{'dropdown.no-preference' | translate}}</option>
                  <option *ngFor="let option of cashRegisters" [ngValue]="option.id">{{ option.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-group">
                <label class="custom-form-label" for="squareMeterType">{{'device-preference.squareMeterType' | translate}}</label>
                <select #squareMeterType="ngModel" id="squareMeterType" name="squareMeterType" [(ngModel)]="deviceLocalStorageData.squareMeterType" class="form-control input-lg">
                  <option [ngValue]="squareMeterTypeEnum.NUMBER_OF_UNIT">{{'squareMeterTypeValue.'+squareMeterTypeEnum.NUMBER_OF_UNIT | translate}}</option>
                  <option [ngValue]="squareMeterTypeEnum.NUMBER_OF_UNIT_TOTAL">{{'squareMeterTypeValue.'+squareMeterTypeEnum.NUMBER_OF_UNIT_TOTAL | translate}}</option>
                  <option [ngValue]="squareMeterTypeEnum.MEASURE">{{'squareMeterTypeValue.'+squareMeterTypeEnum.MEASURE | translate}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="orderListRowsPerPage">{{'device-preference.orderListRowsPerPage' | translate}}</label>
                <select #orderListRowsPerPage="ngModel" id="orderListRowsPerPage" name="orderListRowsPerPage" [(ngModel)]="deviceLocalStorageData.orderListRowsPerPage" class="form-control">
                  <option [ngValue]="item" *ngFor="let item of commonConstant.ROWS_PER_PAGE_OPTIONS">{{item}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="productGridSize">{{'device-preference.productGridSize' | translate}}</label>
                <select name="productGridSize" [(ngModel)]="deviceLocalStorageData.productGridSize" class="form-control">
                  <option [ngValue]="'small'">{{'device-preference.productGridSize-small' | translate}}</option>
                  <option [ngValue]="'large'">{{'device-preference.productGridSize-large' | translate}}</option>
                </select>
              </div>
              <div class="form-check form-switch mb-3">
                <input #showCategoryAsSelectMode="ngModel" type="checkbox" class="form-check-input" name="showCategoryAsSelectMode" id="showCategoryAsSelectMode"
                  [(ngModel)]="deviceLocalStorageData.showCategoryAsSelectMode" />
                <label class="form-check-label" for="showCategoryAsSelectMode">{{'device-preference.show-categories-as-select-mode' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input type="checkbox" class="form-check-input" name="cartPositionLeft" id="cartPositionLeft" [(ngModel)]="deviceLocalStorageData.cartPositionLeft" />
                <label class="form-check-label" for="cartPositionLeft">{{'device-preference.cartPositionLeft' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'device-setting.customer-search-settings' | translate">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-check form-switch mb-3">
                <input #showOrdersOnSearchInput="ngModel" type="checkbox" class="form-check-input" name="showOrdersOnSearchInput" id="showOrdersOnSearchInput"
                  [(ngModel)]="deviceLocalStorageData.showOrdersOnSearch" />
                <label class="form-check-label" for="showOrdersOnSearchInput">{{'device-preference.showOrdersOnSearch' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #showDetailCriteriaOnCustomerSearchInput="ngModel" type="checkbox" class="form-check-input" name="showDetailCriteriaOnCustomerSearchInput"
                  id="showDetailCriteriaOnCustomerSearchInput" [(ngModel)]="deviceLocalStorageData.showDetailCriteriaOnCustomerSearch" />
                <label class="form-check-label" for="showDetailCriteriaOnCustomerSearchInput">{{'device-preference.showDetailCriteriaOnCustomerSearch' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #showCardNumberOnSearchInput="ngModel" type="checkbox" class="form-check-input" name="showCardNumberOnSearchInput" id="showCardNumberOnSearchInput"
                  [(ngModel)]="deviceLocalStorageData.showCardNumberOnSearch" />
                <label class="form-check-label" for="showCardNumberOnSearchInput">{{'device-preference.showCardNumberOnSearch' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #showCustomerIdOnSearchInput="ngModel" type="checkbox" class="form-check-input" name="showCustomerIdOnSearchInput" id="showCustomerIdOnSearchInput"
                  [(ngModel)]="deviceLocalStorageData.showCustomerIdOnSearch" />
                <label class="form-check-label" for="showCustomerIdOnSearchInput">{{'device-preference.showCustomerIdOnSearch' | translate}}</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-group">
                <label class="custom-form-label" for="orderSearchModeInput">{{'device-preference.orderSearchMode' | translate}}</label>
                <select #orderSearchModeInput="ngModel" id="orderSearchModeInput" name="orderSearchModeInput" [(ngModel)]="deviceLocalStorageData.orderSearchMode" class="form-control input-lg">
                  <option value="ORDER">{{'dropdown.order' | translate}}</option>
                  <option value="CUSTOMER">{{'dropdown.customer' | translate}}</option>
                  <option value="DELIVER">{{'dropdown.deliver' | translate}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="customerSearchFocusField">{{'device-preference.customerSearchFocusField' | translate}}</label>
                <select #customerSearchFocusField="ngModel" id="customerSearchFocusField" name="customerSearchFocusField" [(ngModel)]="deviceLocalStorageData.focusFieldOnCustomerSearch"
                  class="form-control input-lg">
                  <option [ngValue]="customerSearchFocusFieldEnum.ORDER_ID">{{'order.orderCode' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.CUSTOMER_ID">{{'customer.customerId' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.CARD_NUMBER">{{'customer.cardNumber' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.CUSTOMER_NAME">{{'customer.customerName' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.FIRST_NAME">{{'customer.firstName' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.LAST_NAME">{{'customer.lastName' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.PHONE_NUMBER">{{'communication.phone' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.ADDRESS">{{'address.description' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.SITE_NAME">{{'address.siteName' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.BUILDING_NAME">{{'address.buildingName' | translate}}</option>
                  <option [ngValue]="customerSearchFocusFieldEnum.DOOR_NUM">{{'address.doorNum' | translate}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="custom-form-label" for="customerSearchRowsPerPage">{{'device-preference.customerSearchRowsPerPage' | translate}}</label>
                <select #customerSearchRowsPerPage="ngModel" id="customerSearchRowsPerPage" name="customerSearchRowsPerPage" [(ngModel)]="deviceLocalStorageData.customerSearchRowsPerPage"
                  class="form-control">
                  <option [ngValue]="item" *ngFor="let item of commonConstant.ROWS_PER_PAGE_OPTIONS">{{item}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'device-setting.call-settings' | translate">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-check form-switch mb-3">
                <input #isCallerIdActiveInput="ngModel" type="checkbox" class="form-check-input" name="isCallerIdActiveInput" id="isCallerIdActiveInput"
                  [(ngModel)]="deviceLocalStorageData.isCallerIdActive" />
                <label class="form-check-label" for="isCallerIdActiveInput">{{'device-preference.isCallerIdActive' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #isVoipActiveInput="ngModel" type="checkbox" class="form-check-input" name="isVoipActiveInput" id="isVoipActiveInput" [(ngModel)]="deviceLocalStorageData.isVoipActive" />
                <label class="form-check-label" for="isVoipActiveInput">{{'device-preference.isVoipActive' | translate}}</label>
              </div>
              <div class="form-group" *ngIf="deviceLocalStorageData.isVoipActive">
                <label class="custom-form-label" for="voipId">{{'voip.name' | translate}}</label>
                <div class="input-group">
                  <select name="voipId" [(ngModel)]="deviceLocalStorageData.voipInternalId" class="form-control" required>
                    <option [ngValue]="0">{{'dropdown.no-preference' | translate}}</option>
                    <option *ngFor="let option of voipInternals" [ngValue]="option.id">{{ option.name }}</option>
                  </select>
                  <div class="input-group-append" *ngxPermissionsOnly="[roleCodeEnum.VOIP_INTERNAL_CREATE]">
                    <button class="btn btn-primary btn-input-group-append btn-icon-only btn-sm" type="button" (click)="openVoipInternalAddUpdateModal()" triggers="mouseenter:mouseleave"
                      placement="top" container="body" [ngbPopover]="'button.add-new' | translate">
                      <i class="fa fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab [heading]="'title.notification-options' | translate">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-4">
              <div class="form-check form-switch mb-3">
                <input #showUnSawedOrderNotification="ngModel" type="checkbox" class="form-check-input" name="showUnSawedOrderNotification" id="showUnSawedOrderNotification"
                  [(ngModel)]="deviceLocalStorageData.showUnSawedOrderNotification" />
                <label class="form-check-label" for="showUnSawedOrderNotification">{{'device-preference.show-unsawed-order-notifications' | translate}}</label>
              </div>
              <div class="form-check form-switch mb-3">
                <input #showOperationalDemandNotification="ngModel" type="checkbox" class="form-check-input" name="showOperationalDemandNotification" id="showOperationalDemandNotification"
                  [(ngModel)]="deviceLocalStorageData.showOperationalDemandNotification" />
                <label class="form-check-label" for="showOperationalDemandNotification">{{'device-preference.show-operational-demand-notifications' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
  </tabset>
</form>